import { Badge, Box, Tooltip } from '@mui/material'
import SvgIcon from '@mui/material/SvgIcon'

import mainColors from '@/styles/mainColors'

type ActivityBarButtonProps = {
	icon: typeof SvgIcon
	label: string
	active?: boolean
	badgeCount?: number
	disabled?: boolean
	onClick?: () => void
	testId?: string
}

export const ActivityBarButton = ({
	icon: Icon,
	label,
	active = false,
	badgeCount,
	disabled = false,
	onClick,
	testId,
}: ActivityBarButtonProps) => {
	const accent = '#1F4954'
	const dim = '#6A6A6A'

	const iconNode = (
		<Box
			sx={{
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				width: '100%',
				py: '11px',
				color: active ? accent : dim,
				bgcolor: active ? 'rgba(31,73,84,0.10)' : 'transparent',
				opacity: disabled ? 0.4 : 1,
				transition: 'background-color 0.12s ease, color 0.12s ease',
				...(!disabled && {
					'&:hover': {
						color: accent,
						bgcolor: active ? 'rgba(31,73,84,0.10)' : 'rgba(31,73,84,0.08)',
					},
				}),
			}}
		>
			<Icon sx={{ fontSize: 22 }} />
		</Box>
	)

	return (
		<Tooltip title={label} placement="right" enterDelay={400}>
			<Box
				component="button"
				type="button"
				aria-label={label}
				aria-current={active ? 'page' : undefined}
				disabled={disabled}
				onClick={onClick}
				data-testid={testId}
				sx={{
					position: 'relative',
					display: 'flex',
					width: '100%',
					alignItems: 'center',
					justifyContent: 'center',
					p: 0,
					border: 0,
					bgcolor: 'transparent',
					cursor: disabled ? 'default' : 'pointer',
					pointerEvents: disabled ? 'none' : 'auto',
					'&::before': {
						content: '""',
						position: 'absolute',
						top: '50%',
						left: 0,
						width: 2.5,
						height: active ? 22 : 0,
						borderRadius: '0 2px 2px 0',
						transform: 'translateY(-50%)',
						bgcolor: mainColors.danger,
						transition: 'height 0.15s ease',
					},
				}}
			>
				{badgeCount != null && badgeCount > 0 ? (
					<Badge
						badgeContent={badgeCount}
						overlap="circular"
						sx={{
							'& .MuiBadge-badge': {
								backgroundColor: mainColors.danger,
								fontSize: 9,
								height: 15,
								minWidth: 15,
								right: 2,
								top: 2,
							},
						}}
					>
						{iconNode}
					</Badge>
				) : (
					iconNode
				)}
			</Box>
		</Tooltip>
	)
}
